import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useEffect, useMemo, useState } from 'react';
const STORAGE_KEY = 'ssc-theme';
export const ThemeContext = createContext(null);
function resolver(mode) {
    if (mode !== 'system')
        return mode;
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}
function leerInicial() {
    try {
        const v = localStorage.getItem(STORAGE_KEY);
        if (v === 'light' || v === 'dark' || v === 'system')
            return v;
    }
    catch {
        /* ignore */
    }
    return 'system';
}
export function ThemeProvider({ children }) {
    const [mode, setModeState] = useState(leerInicial);
    const [resolved, setResolved] = useState(() => resolver(leerInicial()));
    const aplicar = useCallback((m) => {
        const r = resolver(m);
        document.documentElement.dataset.theme = r;
        setResolved(r);
    }, []);
    const setMode = useCallback((m) => {
        try {
            localStorage.setItem(STORAGE_KEY, m);
        }
        catch {
            /* ignore */
        }
        setModeState(m);
        aplicar(m);
    }, [aplicar]);
    useEffect(() => {
        if (mode !== 'system')
            return;
        const mq = window.matchMedia('(prefers-color-scheme: dark)');
        const handler = () => aplicar('system');
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, [mode, aplicar]);
    const value = useMemo(() => ({ mode, resolved, setMode }), [mode, resolved, setMode]);
    return _jsx(ThemeContext.Provider, { value: value, children: children });
}
